import { createContext, type ReactNode, useContext, useMemo } from 'react'

import { fetchPrinciples } from '@/api'
import { useAsync } from '@/hooks'
import type { Principle } from '@/types'

const PrinciplesContext = createContext<Map<string, Principle>>(new Map())

/** Loads the FAIR principles once, so any code like "F1" can explain itself. */
export function PrinciplesProvider({ children }: { children: ReactNode }) {
    const { data } = useAsync(fetchPrinciples, [])
    const value = useMemo(() => new Map((data ?? []).map((item) => [item.id, item])), [data])
    return <PrinciplesContext.Provider value={value}>{children}</PrinciplesContext.Provider>
}

export function usePrinciple(id: string): Principle | undefined {
    return useContext(PrinciplesContext).get(id)
}
